import React, {useState} from 'react'
import Layout from '../components/layout'
import Head from '../components/head'
import {navigate} from 'gatsby'
import { useForm } from 'react-hook-form';
import rawEmojis from '../../static/emojis/emojis'
import * as contactStyle from './pageStyles/contact-style.module.scss'
import * as formStyle from '../components/componentStyles/contact.module.scss'

function encode(data) {
    return Object.keys(data)
      .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
      .join('&')
  }

  export default function ContactPage() {
    const [state, setState] = useState({})
    const { register } = useForm();

    const handleChange = (e) => {
      setState({ ...state, [e.target.name]: e.target.value })
    }
  
    const handleSubmit = (e) => {
      e.preventDefault()
      const form = e.target
      fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: encode({
          'form-name': form.getAttribute('name'),
          ...state,
        }),
      })
        .then(() => navigate(form.getAttribute('action')))
        .catch((error) => alert(error))
    }
  
    return (
      <Layout>
         <Head title="Contact" />
         <div className={contactStyle.content}>
                <h3>Reach me here {rawEmojis.point_down+rawEmojis.point_down+rawEmojis.point_down}</h3>
                <p>If you have any queries or wanna let me know something concerning<br/>an idea or opportunity, please send me a  message from here.<br/>Inshallah, I will get back to you asap.</p>
        
                <form
                    name="contact"
                    method="post"
                    action="/thanks/"
                    data-netlify="true"
                    data-netlify-honeypot="bot-field"
                    onSubmit={handleSubmit}
                    className={formStyle.formDiv}
                    >
                {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
                <input type="hidden" name="form-name" value="contact" />
                <p hidden>
                    <label>
                    Don’t fill this out: <input name="bot-field" onChange={handleChange} />
                    </label>
                </p>

                <div className={formStyle.nameEmail}>

                    <label htmlFor="Name">Name:</label>
                    <input id="Name" className={formStyle.name} type="text" placeholder="Your Name" onChange={handleChange} name="name" ref={register({required: true, min: 5, maxLength: 80})} />

                    <label htmlFor="Email">Email:</label>
                    <input id="Email" className={formStyle.email} type="email" placeholder="Your Email" onChange={handleChange} name="email" ref={register({required: true, pattern: /^\S+@\S+$/i})} />

                </div>

                <div className={formStyle.textAreaButton}>

                    <label htmlFor="Message">Message:</label>
                    <textarea id="Message" className={formStyle.textArea} placeholder="Your Message" onChange={handleChange} name="message" ref={register({required: true, max: 500})} />

                    <button className={formStyle.submitButton} type="submit">Send</button>
                    {/* <input value="Send" type="submit" /> */}
                </div>
          </form>
        
        </div>
      </Layout>
    )
  }
